// Условия списка схем в адресе страницы (010: сценарий 8, п. 1; contracts/api.md 010,
// GET /api/templates): поиск по названию и подписи, состояние «Действующие» / «Архив», сортировка
// по названию или дате и template — открытая карточка схемы справа: /settings/protocols?template=<id>
// (тост подключения и выноски мастера ведут сюда). Значения по умолчанию в адрес не пишутся.
export interface ProtocolsSearch {
  q?: string;
  /** Архив; нет — действующие. */
  state?: 'archived';
  /** Новые сверху; нет — по названию. */
  sort?: '-updatedAt';
  /** Открытая карточка схемы. */
  template?: string;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Для адреса страницы: validateSearch маршрута /settings/protocols. */
export function parseProtocolsSearch(search: Record<string, unknown>): ProtocolsSearch {
  const result: ProtocolsSearch = {};
  if (typeof search.q === 'string' && search.q.trim() !== '') result.q = search.q;
  if (search.state === 'archived') result.state = 'archived';
  if (search.sort === '-updatedAt') result.sort = '-updatedAt';
  if (typeof search.template === 'string' && UUID.test(search.template)) {
    result.template = search.template;
  }
  return result;
}

/** «Изменить карту»: /settings/protocols/new?template=<id>. */
export interface OnboardingSearch {
  template?: string;
}

export function parseOnboardingSearch(search: Record<string, unknown>): OnboardingSearch {
  return typeof search.template === 'string' && UUID.test(search.template)
    ? { template: search.template }
    : {};
}

export const protocolsSortLabels = {
  title: 'название',
  '-updatedAt': 'дата',
} as const;
